import { Component, OnInit, Input } from '@angular/core';
import * as _ from 'lodash';
import { MyReportsRest } from '../services/myreports.service';
import { UiService } from '../../../../services/core.ui.service';
import { GfTranslateService } from '../../../../services/core.translate.service';
import { BreadcrumbService } from '../../../../../widgets/breadcrumbs/breadcrumbs.service';
import { StateService } from '@uirouter/angular';
import { marker } from '../../../../services/ngx-translate-extract-marker';

@Component({
  selector: 'my-reports-view',
  template: require('./myreports.report.component.html')
})
export class MyReportsReportComponent implements OnInit {
  columnOrder: string[];
  @Input() user: any;
  @Input() myReport: any;
  @Input() myReports: any;

  myReportData: any = false;
  myReportColumns: any = false;
  userCanEdit: boolean = false;
  crumbs: any[];

  constructor(
    public stateService: StateService,
    private myReportsRest: MyReportsRest,
    private uiService: UiService,
    private translateService: GfTranslateService,
    private breadcrumbService: BreadcrumbService
  ) {}

  ngOnInit() {
    // User can edit the report filters if he's the report owner.
    this.userCanEdit = _.get(this, 'myReport.user.id', 0) === _.get(this, 'user.id', 100);

    this.crumbs = [
      this.breadcrumbService.userMyPageCrumb(this.user),
      this.breadcrumbService.translatedCrumb(marker('My Reports'), 'home.user.myreports', {}),
      this.breadcrumbService.stateCrumb(this.myReport.reportName, 'home.user.myreports.report', { id: this.myReport.id })
    ];

    if (_.get(this, 'myReport.id', 0) > 0) {
      this.getReportData();
    } else {
      this.myReportData = [];
      this.myReportColumns = [];
    }
  }

  onPage(params: any) {
    const currentParams = this.stateService.params;
    const newParams = Object.assign({}, currentParams, params);
    this.stateService.go('.', newParams, {reload: true});
  }

  refresh() {
    this.getReportData();
  }

  getReportData() {
    this.myReportData = false;
    const id = this.stateService.params.id || this.myReport.id;
    this.myReportsRest.getData(id, this.stateService.params)
      .then(response => {
        this.myReportData = _.get(response, 'items', []);
        this.myReportColumns = _.sortBy(_.get(response, 'meta', []), 'columnOrder');
      })
      .catch(err => {
        console.error(err);
        this.uiService.message.showError(
          this.translateService.translate("Could not refresh data"),
          this.translateService.translate("Error")
        );
        this.myReportData = [];
        this.myReportColumns = [];
      });
  }

  trackById(index: number, item: any) {
    return item.id;
  }
}
